import { FunctionComponent, memo, useContext } from 'react';
import { ConfigContext } from '../../../../context';
import { NotificationLeaderBoard } from '../../../../services';
import { getChannelDomain, getWebAppUrl, layoutPath } from '../../../utils';
import { DefaultContent } from '../Default';
import { NotificationWrapper } from '../NotificationWrapper';

interface LeaderBoardProps {
  notification: NotificationLeaderBoard;
  setIsOpen: (isOpen: boolean) => void;
  logOpen: (notification_id: number) => void;
}

export const LeaderBoard: FunctionComponent<LeaderBoardProps> = memo(
  ({ notification, setIsOpen, logOpen }) => {
    const { defaultLogoUrl } = useContext(ConfigContext).config.elements.notifications;

    const { id, title, message, deliveredTime } = notification;

    const onClickHandler = () => {
      window.open(
        `${getWebAppUrl(getChannelDomain())}${layoutPath('/leaderBoard')}`,
        '_blank',
        'noreferrer'
      );

      logOpen(id);

      setIsOpen(false);
    };

    return (
      <NotificationWrapper
        key={id}
        avatarUrl={defaultLogoUrl}
        deliveredTime={deliveredTime}
        onClick={onClickHandler}
        hasLink
      >
        <DefaultContent title={title} message={message} hasLink />
      </NotificationWrapper>
    );
  }
);
